import { ImageStyled } from './style';

interface ImageProps {
  path: string;
}

export const Image = ({ path }: ImageProps) => <ImageStyled src={path} />;
